var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.layout === 1)?_c('Layout1',{attrs:{"sortBy":this.sortBy}}):_vm._e(),(_vm.item.layout === 2)?_c('Layout2'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }